/** Compute overlap lanes for events on a single day. Returns map id -> { left, width }. */
function layoutKey(ev) {
  return ev.segmentKey || ev.id;
}

export function computeDayLayout(events) {
  const layout = {};
  if (!events?.length) return layout;

  if (events.length === 1) {
    layout[layoutKey(events[0])] = { left: '2px', right: '2px', width: 'auto' };
    return layout;
  }

  const items = [...events]
    .map((ev) => ({ ...ev, start: Number(ev.start), end: Number(ev.end) }))
    .sort((a, b) => a.start - b.start || a.end - b.end);

  const clusters = [];
  let cluster = [items[0]];
  let clusterEnd = items[0].end;
  for (let i = 1; i < items.length; i++) {
    if (items[i].start < clusterEnd) {
      cluster.push(items[i]);
      clusterEnd = Math.max(clusterEnd, items[i].end);
    } else {
      clusters.push(cluster);
      cluster = [items[i]];
      clusterEnd = items[i].end;
    }
  }
  clusters.push(cluster);

  const gap = 2;
  clusters.forEach((group) => {
    if (group.length === 1) {
      layout[layoutKey(group[0])] = { left: `${gap}px`, right: `${gap}px`, width: 'auto' };
      return;
    }

    const laneEnds = [];
    group.forEach((item) => {
      let lane = laneEnds.findIndex((end) => end <= item.start);
      if (lane === -1) {
        lane = laneEnds.length;
        laneEnds.push(item.end);
      } else {
        laneEnds[lane] = item.end;
      }
      item.lane = lane;
    });

    const laneCount = laneEnds.length;
    group.forEach((item) => {
      const widthPct = 100 / laneCount;
      layout[layoutKey(item)] = {
        left: `calc(${item.lane * widthPct}% + ${gap}px)`,
        right: 'auto',
        width: `calc(${widthPct}% - ${gap * 2}px)`,
      };
    });
  });

  return layout;
}

export function computeAllLayouts(events) {
  const byDay = {};
  events.forEach((ev) => {
    if (!byDay[ev.day]) byDay[ev.day] = [];
    byDay[ev.day].push(ev);
  });
  const all = {};
  Object.keys(byDay).forEach((day) => {
    Object.assign(all, computeDayLayout(byDay[day]));
  });
  return all;
}
